import Box from '@mui/material/Box'
import { DataGrid, GridCellProps, GridColDef } from '@mui/x-data-grid'

import { Table as TableType } from 'types/Table'
import TableCellWithToolTip from 'components/Shared/Table/TableCellWithToolTip'
import styles from 'components/Shared/Table/table.module.scss'

type Props = {
  rows: TableType[]
  columns: GridColDef[]
  pageSize?: number
  checkboxSelection?: boolean
  disableColumnMenu?: boolean
  rowsPerPageOptions?: number[]
  disableColumnSelector?: boolean
  disableSelectionOnClick?: boolean
  initialState?: any
  border?: boolean
  height?: string
  disableColumnSeparator?: boolean
  showTabelCellWithTooltip?: boolean
}

const Table = (props: Props) => {
  const {
    rows,
    border,
    height,
    columns,
    pageSize,
    checkboxSelection,
    disableColumnMenu,
    disableColumnSelector,
    disableSelectionOnClick,
    rowsPerPageOptions,
    initialState,
    disableColumnSeparator,
    showTabelCellWithTooltip,
  } = props

  return (
    <Box style={{ height: height }}>
      <DataGrid
        components={{
          Cell: (props: GridCellProps) => (
            <TableCellWithToolTip
              showTabelCellWithTooltip={showTabelCellWithTooltip}
              {...props}
            />
          ),
        }}
        rows={rows}
        columns={columns}
        pageSize={pageSize}
        initialState={initialState}
        rowsPerPageOptions={rowsPerPageOptions}
        checkboxSelection={checkboxSelection}
        disableColumnMenu={disableColumnMenu}
        disableColumnSelector={disableColumnSelector}
        disableSelectionOnClick={disableSelectionOnClick}
        columnVisibilityModel={{
          id: false,
        }}
        classes={{
          cell: `${styles['rectangularTable_cell']}`,
          columnHeader: `${styles['rectangularTable_header_cell']}`,
          columnSeparator: disableColumnSeparator
            ? `${styles['rectangularTable_column_separator']}`
            : '',
        }}
        sx={{
          border: border ? '' : 'none',
        }}
      />
    </Box>
  )
}

export default Table
